<template>
    <v-app>
        <v-container class="maintenance-view" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="6" md="4">
                    <v-card class="maintenance-card pa-2" elevation="10">
                        <v-card-title>OTISAK.ORG | Radovi na sajtu</v-card-title>
                        <v-card-text class="text-body-1 text--black">
                            Otisak.org je platforma koja građanima nudi jedinstvenu mogućnost da provere koliko su im
                            bezbedni i zaštićeni podaci o ličnosti (JMBG, ime i prezime, mejl itd.) koje ostave i povere
                            nekom državnom organu ili nekoj privatnoj kompaniji.
                        </v-card-text>
                        <v-card-actions>
                            <span class="pl-2">
                                Pročitaj više o projektu na
                                <OtisakLink to="https://pravilaw.rs/platforma-otisak/">Pravilaw</OtisakLink>-u.
                            </span>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
            <v-fab-transition>
                <v-btn fab small dark bottom left class="btn-login elevation-2" href="/login">
                    <v-icon>mdi-account</v-icon>
                </v-btn>
            </v-fab-transition>
        </v-container>
    </v-app>
</template>

<script>
import OtisakLink from "@/components/OtisakLink";

export default {
    name: 'Maintenance',

    components: {
        OtisakLink
    }
}
</script>

<style lang="scss" scoped>
.maintenance-view {
    background-image: url('../../public/images/backgounds/login.jpg');
    background-size: cover;
    object-fit: cover;
    background-position: 50% 50%;
    height: 100vh;
    display: flex;
    align-items: center;

    .btn-login {
        bottom: 0;
        position: absolute;
        margin: 0 0 16px 16px;
    }

    .maintenance-card {
        background-color: rgba(255, 255, 255, 0.86) !important;
        backdrop-filter: blur(4px);
    }
}
</style>
